import { useControllableState } from "@imwebme/clay-hooks";
import { useId } from "react";
import { Flex } from "../utilities";
import { TabProvider } from "./Tab.provider";
import type { TabsProps } from "./Tabs.types";

export const Tabs = ({
  direction = "horizontal",
  size = "medium",
  fullWidth = false,
  defaultIndex = 0,
  ...props
}: TabsProps) => {
  const [activeIndex, setActiveIndex] = useControllableState({
    value: props.index,
    defaultValue: defaultIndex,
    onChange: props.onChange,
  });

  const id = useId();

  return (
    <TabProvider
      activeIndex={props.index ?? activeIndex}
      setActiveIndex={setActiveIndex}
      direction={direction}
      variant={props.variant}
      size={size}
      fullWidth={fullWidth}
      underline={props.variant === "text" ? props.underline : false}
      uniqueId={id}
    >
      <Flex flexDirection={direction === "horizontal" ? "column" : "row"} overflow="hidden">
        {props.children}
      </Flex>
    </TabProvider>
  );
};
